import { api, ApiError } from './client';

/** Bandeja de aprobaciones del negocio activo (estándar Codeus). Prefijo: /api/aprobaciones */

export type EstadoAprobacion = 'pendiente' | 'aprobando' | 'aprobada' | 'rechazada' | 'fallida' | 'vencida' | 'interrumpida';

export interface Aprobacion {
  id: string;
  area: string;
  areaNombre: string;
  topeId: string;
  tope: string;
  metodo: string;
  url: string;
  /** El patrón de la ruta que se congeló (`POST /api/tienda/ventas/:id/devolver`). */
  ruta: string | null;
  cuerpoJson: unknown;
  pedido: number;
  limite: number;
  motivo: string | null;
  estado: EstadoAprobacion;
  resueltoAt: string | null;
  resultadoJson: unknown;
  createdAt: string;
  solicitante: { name: string | null; email: string };
  resueltoPor: { name: string | null; email: string } | null;
  rolDeNegocio: { nombre: string } | null;
  mia: boolean;
  puedoResolver: boolean;
}

/**
 * ¿La petición pasó un tope y quedó esperando en «Aprobaciones»? El servidor contesta 403 con
 * el número de la aprobación: no es un error, es «lo aprueba otra persona». La pantalla lo
 * avisa así y cierra el formulario (lo pedido no se pierde: está en la bandeja).
 */
export function quedoEnAprobaciones(e: unknown): e is ApiError {
  return e instanceof ApiError && e.status === 403 && typeof (e.details as { aprobacionId?: unknown } | undefined)?.aprobacionId === 'string';
}
export const AVISO_DE_APROBACION = 'Quedó en Aprobaciones';

export const listar = (estado: 'pendiente' | 'resueltas' | 'todas') =>
  api.get<{ areasQueApruebo: string[]; aprobaciones: Aprobacion[] }>(`/api/aprobaciones?estado=${estado}`);
export const aprobar = (id: string) => api.post<{ id: string; estado: 'aprobada' }>(`/api/aprobaciones/${id}/aprobar`, {});
export const rechazar = (id: string, motivo?: string) => api.post<{ id: string; estado: 'rechazada' }>(`/api/aprobaciones/${id}/rechazar`, { motivo });
